import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section id="cart-content" data-nav="light" className="w-full bg-background text-foreground py-12 md:py-16 lg:py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
        <div className="w-full">
          <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}